export const toggleModal = (name) => {
    return {
        type : 'TOGGLE_MODAL',
        payload : {
            name
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/Navigation/actions/modalActions.js